
import MoveService from "../../services/Move";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "moves";

function useListMoves({ enabled = true } = {}) {
  return useAuthorizedQuery(QUERY_KEY, () => MoveService.listMoves(), { enabled });
}

export default useListMoves;
